import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { PurchasingService } from "src/app/modules/planyard/purchasing.service";
import { DialogActions } from "src/app/components/dialogs/dialog.model";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { SaveProductEvent } from "src/app/models/purchasing.model";


@Component({
  selector: "app-add-event-dialog",
  templateUrl: "./add-event-dialog.component.html",
  styleUrls: ["./add-event-dialog.component.scss"],
})
export class AddEventDialogComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  actions: DialogActions[] = [
    { text: "Cancel", buttonStyle: "underline" },
    { text: "Confirm", isDisabled: true },
  ];
  title: string;
  minDate = new Date();
  form: FormGroup = new FormGroup({
    description: new FormControl('', Validators.required),
    eventDate: new FormControl('', Validators.required),
    amount: new FormControl('', Validators.required),
  });
  constructor(
    private dialogRef: MatDialogRef<AddEventDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data:{event?: SaveProductEvent, productId: number},
    private purchasingService: PurchasingService
  ) {}

  ngOnInit(): void {
    this.title = `${this.data.event?.productEventId ? "Edit" : "Add"} event`;
   
    this.form.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((e) => {
      if (this.form.valid) {
        this.actions[1].isDisabled = false;
      } else {
        this.actions[1].isDisabled = true;
      }
    });

    if (this.data.event) {
      this.form.patchValue(this.data.event);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  close() {
    this.dialogRef.close();
  }

  action(e: string) {
    if (e === "Confirm") {
      this.save();
    } else if (e === 'Cancel') {
      this.dialogRef.close()
    }
  }

  save() {
    const payload: SaveProductEvent = {
      ...this.form.value,
    };
    payload.productId = this.data.productId;
    if (this.data.event?.productEventId) {
      payload.productEventId = this.data.event.productEventId
    }
    this.purchasingService.SaveProductEvent(payload).pipe(takeUntil(this.destroy$)).subscribe((e) => {
      this.dialogRef.close(payload)
    });
  }
}
